<template>
  <ul class="pages">
    <li :class="['page-item', {disabled: disabled || page == 1}]">
      <router-link :to="{query: {...query, 'page': page-1}}" class="page-link">&laquo;</router-link>
    </li>

    <li v-for="p in pages" :key="p" :class="{'page-item': true, active: p==page, disabled: disabled}">
      <router-link :to="{query: {...query, 'page': p}}" class="page-link">{{ p }}</router-link>
      <!-- <a
        @click.prevent="$store.dispatch('changePage', p)"
        :href="{query: {'page': p}}"
        class="page-link"
      >{{ p }}</a> -->
    </li>

    <li :class="['page-item', {disabled: disabled || page == pages}]">
      <router-link :to="{query: {...query, 'page': page+1}}" class="page-link">&raquo;</router-link>
    </li>
  </ul>
</template>

<script>
export default {

    props: {
        disabled: Boolean,
        page: Number,
        pages: Number,
    },

    computed: {
        query() {
            return this.$route.query;
        },
    },
};
</script>

<style>
</style>


